import { ingestImage } from '../assets/ingestImage';

/**
 * Content-hash store a Lottie document (local IndexedDB + background cloud
 * upload) and return its stable `asset://<id>` ref. `ingestImage`'s pipeline is
 * media-agnostic — only the name says image — so we reuse it with a JSON blob.
 */
export async function ingestLottieJson(doc: unknown): Promise<string> {
  const blob = new Blob([typeof doc === 'string' ? doc : JSON.stringify(doc)], { type: 'application/json' });
  return ingestImage(blob);
}
